module.exports = __webpack_public_path__ + "img/T4-D-xs_11.ffff7d6a.png";